<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />
        <div class="container">
          <div class="card mt-4">
            <div class="row">
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="card-body">
                  <b-form inline>
                    <b-button   variant="primary" v-on:click="marcarAsistencia(0)">
                      Marcar entrada
                    </b-button>
                    <b-button class="ml-2"  variant="primary" v-on:click="marcarAsistencia(1)">
                      Marcar salida
                    </b-button>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
          <div class="row" >
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>ID</th>
                <th>Nombres</th>
                <th>Fecha entrada</th>
                <th>fecha salida</th>
                <!--<th>Descargar para firma</th>-->
                <!--<th>Archivo firmado</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="(data, index) in asistencias" v-bind:key="index">
                <td>{{data.user_id}}</td>
                <td>{{data.nombres}}</td>
                <td>{{data.fecha_entrada}}</td>
                <td>{{data.fecha_salida}}</td>
                <!--<td><a href="#" v-on:click="descargarPDF(data)"> Descargar </a></td>-->
                <!--<td></td>-->
              </tr>
              </tbody>
            </table>
          </div>
        </div>



      </div>
    </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Asistencia",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,

  },
  data() {
    return {
      title: "Asistencia",
      items: [
        {
          text: "Asistencia",
          href: "/"
        },
        {
          text: "Marcar asistencia",
          active: true
        }
      ],
      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      datetime2: new Date(),
      asistencias:[]
    };
  },

  methods: {
    descargarPDF(data){
      this.isLoading = true;
      /*this.axios.get(
              process.env.VUE_APP_BACKEND + "/api/generar-asistencia-pdf",
              {'params':data})
              .then(()=> {
                //this.asistencias=response.data;
              })
              .catch(() => {
                this.$swal("error", "Error", "error");
              })
              .finally(() => {
                this.isLoading = false;

              });*/

      this.$http.get(process.env.VUE_APP_BACKEND + "/api/generar-asistencia-pdf",
              {
                responseType: 'arraybuffer',
                'params':data
              })
              .then(response => {
                this.downloadFile(response, 'customFilename')
              }, response => {
                console.warn('error from download_contract')
                console.log(response)
                // Manage errors
              });

    },
    downloadFile(response, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([response.body], {type: 'application/pdf'})

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = data
      link.download = filename + '.pdf'
      link.click()
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data)
      }, 100)
    },
    loadItems()
    {
      this.isLoading = true;
      this.axios.get(
              process.env.VUE_APP_BACKEND + "/api/asistencias",

      )
              .then((response)=> {
                this.asistencias=response.data;
              })
              .catch(() => {
                this.$swal("error", "Error", "error");
              })
              .finally(() => {
                this.isLoading = false;

              });
    },
    marcarAsistencia(indicador){

      this.$swal
              .fire({
                title: "¿Esta seguro de marca asistencia?",
                text: "-",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#4049D8",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Si, Marcar",
                showLoaderOnConfirm: true
              })
              .then(result => {
                if (result.value) {
                  this.isLoading = true;
                  this.axios.post(
                                  process.env.VUE_APP_BACKEND + "/api/asistencias",
                                  {
                                    indicador:indicador
                                  }
                          )
                          .then((response)=> {
                              this.$swal("OK", response.data.mensaje, "success");
                          })
                          .catch((ee) => {
                            console.log(ee.response.data.mensaje);
                            this.$swal("Cuidado", ee.response.data.mensaje, "warning");
                          })
                          .finally(() => {
                            this.isLoading = false;
                            this.loadItems();
                          });
                }
              });

    }

   },
  mounted() {
    this.loadItems();
  }

};
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
